import React from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Input,
  Paper,
  Radio,
  RadioGroup,
  Stack,
  Switch,
  TextField,
  useTheme,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Avatar,
  Select,
  MenuItem,
  InputLabel,
  Typography,
  Chip,
  Checkbox,
  OutlinedInput,
  Toolbar,
  Tooltip,
  IconButton,
  Snackbar,
  Alert,
  Autocomplete,
} from "@mui/material";
import { tokens } from "../theme";
import { useState, useEffect } from "react";
import Header from "../components/Header";
import { toast } from "react-toastify";
import {
  Add,
  Delete,
  MailOutline,
  MarkEmailRead,
  MarkEmailUnread,
  Visibility,
} from "@mui/icons-material";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
import debounce from "lodash.debounce";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TrendingUp, Schedule, Cancel } from "@mui/icons-material";
import { useUser } from "../provider/AuthProvider";
import axios from "axios";
import BreadcrumbsBar from "../components/BreadcrumbsBar";
import ConfirmDialog from "../components/ComfirmationDialog";
import stringToColor from "../services/stringToColor";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

import { useTranslation } from "react-i18next";
const CustomToolbar = () => (
  <GridToolbarContainer>
    <GridToolbarExport printOptions={{ disableToolbarButton: true }} />
  </GridToolbarContainer>
);

const NotificationPage = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [title, setTitle] = useState("");
  const [isInbox, setIsInbox] = useState("inbox");
  const [message, setMessage] = useState("");
  const [toUserIds, setToUserIds] = useState("");
  const [sendNow, setSendNow] = useState(true);
  const [scheduleAt, setScheduleAt] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [inbox, setInbox] = useState([]);
  const [outbox, setOutbox] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [filterType, setFilterType] = useState("");
  const [filterDate, setFilterDate] = useState("1y");
  const [userList, setUserList] = useState([]);
  const [userFilter, setUserFilter] = useState({ search: "" });
  const [recipientScope, setRecipientScope] = useState("everyone");
  const [customStartDate, setCustomStartDate] = useState(null);
  const [customEndDate, setCustomEndDate] = useState(null);
  const [customDateValid, setCustomDateValid] = useState(true);
  const { t, i18n } = useTranslation();
  const [stats, setStats] = useState({
    scheduled: 0,
    delivered: 0,
    undelivered: 0,
  });
  const [todayScheduled, setTodayScheduled] = useState([]);
  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const { user, loading } = useUser();
  const [selectedNotification, setSelectedNotification] = useState(null);
  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmit, setSubmit] = useState(false);

  useEffect(() => {
    if (!loading && user?.id) {
      axios
        .get(`${process.env.REACT_APP_BACKEND_URL}/api/notify/stats/${user.id}`)
        .then((res) => setStats(res.data))
        .catch(console.error);

      axios
        .get(
          `${process.env.REACT_APP_BACKEND_URL}/api/notify/today-scheduled/${user.id}`
        )
        .then((res) => setTodayScheduled(res.data))
        .catch(console.error);
    }
  }, [loading, user]);

  const handleSubmit = async () => {
    if (!title || !message || !toUserIds.length)
      return toast.error("All fields required");
    setSubmit(true);
    const payload = {
      title,
      message,
      type: "manual",
      send_type: sendNow ? "immediate" : "scheduled",
      schedule_at: sendNow ? null : scheduleAt,
      to_user_ids: toUserIds,
      from_user_id: user.id,
      type: "MAINTENANCE",
    };

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/notify/create`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      setSnack({
        open: true,
        message: t("notification_page.notification_created"),
        severity: "success",
      });

      setTitle("");
      setMessage("");
      setToUserIds([]);
      fetchNotification();
      setOpenDialog(false);
    } catch (err) {
      setSnack({
        open: true,
        message: t("notification_page.notification_send_failed"),
        severity: "error",
      });
    } finally {
      setSubmit(false);
    }
  };

  const fetchUserList = async (search = "") => {
    const res = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/users?search=${search}`
    );
    const data = await res.json();
    setUserList(data);
    setToUserIds([]);
  };

  const handleSearchChange = debounce((e) => {
    setUserFilter({ ...userFilter, search: e.target.value });
    fetchUserList(e.target.value);
  }, 500);

  useEffect(() => {
    fetchNotification();
    fetchUserList();
  }, [isInbox]);

  const fetchNotification = async () => {
    if (!user?.id) return;
    try {
      setIsLoading(true);
      const inboxRes = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/notify/inbox/${user.id}`
      );
      const outboxRes = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/notify/outbox/${user.id}`
      );
      setInbox(inboxRes.data);
      setOutbox(outboxRes.data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const filterByDate = (dateString, filterKey) => {
    const date = new Date(dateString);
    const now = new Date();

    switch (filterKey) {
      case "today":
        return date.toDateString() === now.toDateString();
      case "1m":
        return date > new Date(now.setMonth(now.getMonth() - 1));
      case "3m":
        return date > new Date(now.setMonth(now.getMonth() - 3));
      case "1y":
        return date > new Date(now.setFullYear(now.getFullYear() - 1));
      case "custom":
        if (!customStartDate || !customEndDate) return true;
        const start = new Date(customStartDate);
        const end = new Date(customEndDate);
        return date >= start && date <= end;
      default:
        return true;
    }
  };

  useEffect(() => {
    filterByDate();
    const isDateRangeValid = () =>
      !customStartDate || !customEndDate || customStartDate <= customEndDate;
    setCustomDateValid(
      !customStartDate || !customEndDate || customStartDate <= customEndDate
    );
  }, [filterDate, customStartDate, customEndDate]);

  const handleView = (row) => {
    setSelectedNotification(row);
    setOpenViewDialog(true);
    if (!row.read) {
      axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/notify/mark-read/${row.id}`
      ).catch(console.error);
      fetchNotification();
    }
  };

  const handleDelete = async (id) => {
    setSelectedNotification(id);
    setDeleteDialogOpen(true);
  };

  const confirmDelete = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/notify/delete/${selectedNotification}`
      );

      setInbox(inbox.filter((n) => n.id !== selectedNotification));
      setOutbox(outbox.filter((n) => n.id !== selectedNotification));
      setSnack({
        open: true,
        message: t("notification_page.notification_deleted"),
        severity: "success",
      });
    } catch {
      setSnack({
        open: true,
        message: t("notification_page.notification_delete_failed"),
        severity: "error",
      });
    } finally {
      setDeleteDialogOpen(false);
    }
  };
  const columns = [
    {
      field: "read",
      headerName: "",
      flex: 0.2,
      renderCell: (params) => (
        <Box>
          {params.row.read == true ? (
            <MarkEmailRead fontSize="small" sx={{ mr: 0.5 }} />
          ) : (
            <MarkEmailUnread
              fontSize="small"
              color="primary"
              sx={{ mr: 0.5 }}
            />
          )}
        </Box>
      ),
    },
    {
      field: "body",
      headerName: t("notification_page.col_body"),
      flex: 1.5,
      renderCell: (params) => (
        <Box>
          <Typography
            variant="h6"
            fontWeight={params.row.read ? "normal" : "bold"}
          >
            {params.row.title}
          </Typography>

          {/* <Tooltip title={params.row.message} placement="bottom-start">
            <Typography variant="body2" noWrap sx={{ maxWidth: 250 }}>
              {params.row.message}
            </Typography>
          </Tooltip> */}
        </Box>
      ),
    },
    {
      field: "send_type",
      headerName: t("notification_page.col_type"),
      flex: 0.7,
      renderCell: (params) => (
        <Chip
          label={params.value}
          color={params.value === "immediate" ? "success" : "warning"}
          size="small"
        />
      ),
    },
    {
      field: "createdAt",
      headerName: t("notification_page.col_sent_at"),
      flex: 1,
      renderCell: (params) => (
        <Typography variant="h6" className="notranslate">
          {new Date(params.row.createdAt).toLocaleString()}
        </Typography>
      ),
    },
    {
      field: "actions",
      headerName: t("notification_page.col_actions"),
      flex: 0.5,
      sortable: false,
      renderCell: (params) => (
        <Box>
          <IconButton onClick={() => handleView(params.row)} size="small">
            <Visibility fontSize="small" />
          </IconButton>
          <IconButton
            onClick={() => handleDelete(params.row.id)}
            size="small"
            color="error"
          >
            <Delete fontSize="small" />
          </IconButton>
        </Box>
      ),
    },
  ];

  return (
    <Box className="main-container mt-4">
      <BreadcrumbsBar />
      <Box display="flex" justifyContent="space-around">
        <Grid
          container
          spacing={2}
          columns={{ xs: 2, sm: 8, md: 10 }}
          rows={{ xs: 3, sm: 3, md: 2 }}
          sx={{
            width: "100%",
          }}
        >
          <Grid item size={{ xs: 2, sm: 2, md: 2 }}>
            <Paper
              sx={{
                padding: 2,
                height: "80vh",
              }}
              elevation={3}
            >
              {/* <Box display="flex" justifyContent="center" m={2}>
                <Button onClick={() => setOpenDialog(true)} variant="contained">
                  <Add /> Add Notification
                </Button>
              </Box>
              <FormControl
                component="fieldset"
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: 1,
                  display: "flex",
                  p: 1, // padding inside border
                }}
              >
                <FormLabel component="legend">User Type</FormLabel>
                <RadioGroup
                  value={isInbox}
                  onChange={(e) => setIsInbox(e.target.value)}
                  row={true}
                >
                  <FormControlLabel
                    value="inbox"
                    control={<Radio />}
                    label="Inbox"
                  />
                  <FormControlLabel
                    value="outbox"
                    control={<Radio />}
                    label="Outbox"
                  />
                </RadioGroup>
              </FormControl>
              <Box mt={3}>
                <FormControl size="small" fullWidth>
                  <InputLabel>Type</InputLabel>
                  <Select
                    value={filterType}
                    onChange={(e) => setFilterType(e.target.value)}
                    label="Type"
                  >
                    <MenuItem value="">All</MenuItem>
                    <MenuItem value="immediate">Instant</MenuItem>
                    <MenuItem value="scheduled">Scheduled</MenuItem>
                  </Select>
                </FormControl>
              </Box> */}
              <Box mt={3}>
                <FormControl size="small" fullWidth>
                  <InputLabel>{t("notification_page.date")}</InputLabel>
                  <Select
                    value={filterDate}
                    onChange={(e) => setFilterDate(e.target.value)}
                    label={t("notification_page.date")}
                  >
                    <MenuItem value="today">{t("notification_page.today")}</MenuItem>
                    <MenuItem value="1m">{t("notification_page.one_month")}</MenuItem>
                    <MenuItem value="3m">{t("notification_page.three_months")}</MenuItem>
                    <MenuItem value="1y">{t("notification_page.one_year")}</MenuItem>
                    <MenuItem value="custom">{t("notification_page.custom")}</MenuItem>
                  </Select>
                  {filterDate === "custom" && (
                    <Box mt={2}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          label={t("notification_page.start_date")}
                          value={customStartDate}
                          onChange={(newValue) => setCustomStartDate(newValue)}
                          slotProps={{
                            textField: { fullWidth: true, margin: "dense" },
                          }}
                        />
                        <DatePicker
                          label={t("notification_page.end_date")}
                          value={customEndDate}
                          onChange={(newValue) => setCustomEndDate(newValue)}
                          slotProps={{
                            textField: { fullWidth: true, margin: "dense" },
                          }}
                        />
                      </LocalizationProvider>
                      {!customDateValid && (
                        <Typography variant="h6" color="error">
                          {t("notification_page.invalid_date_range")}
                        </Typography>
                      )}
                    </Box>
                  )}
                </FormControl>
              </Box>
            </Paper>
          </Grid>
          <Grid item size={{ xs: 2, sm: 2, md: 6 }}>
            <Paper
              sx={{
                p: 2,
                height: "80vh",
                width: "100%",
                overflowX: "auto",
              }}
              elevation={3}
            >
              <div style={{ height: "70vh" }}>
                <DataGrid
                  rows={(isInbox !== "inbox" ? inbox : outbox)
                    .filter((n) => !filterType || n.send_type === filterType)
                    .filter((n) => filterByDate(n.createdAt, filterDate))}
                  columns={columns}
                  getRowId={(row) => row.id}
                  pageSize={pageSize}
                  onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 10,
                      },
                    },
                  }}
                  pageSizeOptions={[5, 10, 15, 20, 25]}
                  pagination
                  getRowHeight={() => "auto"}
                  getRowClassName={(params) =>
                    !params.row.read ? "unread-row" : ""
                  }
                  loading={isLoading}
                  sx={{
                    borderRadius: 2,
                    minWidth: "800px",
                    overflowX: "auto",

                    // "& .MuiDataGrid-virtualScroller": {
                    //   overflowX: "auto !important",
                    // },
                    "& .MuiDataGrid-row:hover": {
                      backgroundColor:
                        theme.palette.mode === "dark"
                          ? "rgba(255,255,255,0.06)"
                          : "#f5f5f5",
                    },
                    "& .MuiDataGrid-cell": {
                      alignItems: "flex-start",
                      lineHeight: 1.4,
                      justifyContent: "left",
                      display: "flex",
                      // margin: "5px",
                      padding: "5px",
                    },
                    "& .unread-row": {
                      backgroundColor:
                        theme.palette.mode === "dark" ? "#1e293b" : "#e3f2fd",
                    },
                  }}
                />
              </div>
            </Paper>
          </Grid>
          <Grid item size={{ xs: 2, sm: 2, md: 2 }}>
            {/* <Box display="flex" justifyContent="center"> */}
            <Stack
              direction="column"
              display="flex"
              justifyContent="space-evenly"
              spacing={5}
            >
              <Paper
                elevation={3}
                sx={{ p: 2, display: "flex", alignItems: "center", gap: 2 }}
              >
                <Schedule color="warning" />
                <Box>
                  <Typography variant="h6">{t("notification_page.scheduled")}</Typography>
                  <Typography variant="h5" color="text.secondary">
                    {stats.scheduled}
                  </Typography>
                </Box>
              </Paper>
              <Paper
                elevation={3}
                sx={{ p: 2, display: "flex", alignItems: "center", gap: 2 }}
              >
                <TrendingUp color="success" />
                <Box>
                  <Typography variant="h6">{t("notification_page.delivered")}</Typography>
                  <Typography variant="h5" color="text.secondary">
                    {stats.delivered}
                  </Typography>
                </Box>
              </Paper>
              <Paper
                elevation={3}
                sx={{ p: 2, display: "flex", alignItems: "center", gap: 2 }}
              >
                <Cancel color="error" />
                <Box>
                  <Typography variant="h6">{t("notification_page.undelivered")}</Typography>
                  <Typography variant="h5" color="text.secondary">
                    {stats.undelivered}
                  </Typography>
                </Box>
              </Paper>
              <Paper
                sx={{
                  padding: 2,
                  height: "40vh",
                }}
                elevation={3}
              >
                <Typography variant="h6" mb={1}>
                  {t("notification_page.todays_scheduled")}
                </Typography>
                {todayScheduled.length === 0 ? (
                  <Typography color="text.secondary">
                    {t("notification_page.no_scheduled_today")}
                  </Typography>
                ) : (
                  <Box>
                    {todayScheduled?.map((n) => (
                      <Box key={n.id} borderBottom="1px solid #eee" py={1}>
                        <Typography variant="subtitle1">{n.title}</Typography>
                        <Typography variant="body2" color="text.secondary">
                          {new Date(n.schedule_at).toLocaleString()} -{" "}
                          {n.recipient_scope}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                )}
              </Paper>
            </Stack>
          </Grid>
        </Grid>
      </Box>
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>{t("notification_page.create_notification")}</DialogTitle>
        <DialogContent>
          <TextField
            label={t("notification_page.title")}
            fullWidth
            margin="dense"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <TextField
            label={t("notification_page.message")}
            fullWidth
            margin="dense"
            multiline
            rows={4}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
          <FormControl fullWidth margin="dense">
            <InputLabel>{t("notification_page.recipient_scope")}</InputLabel>
            <Select
              value={recipientScope}
              onChange={(e) => setRecipientScope(e.target.value)}
              label={t("notification_page.recipient_scope")}
            >
              <MenuItem value="tenants">{t("notification_page.tenants_only")}</MenuItem>
              <MenuItem value="landlords">{t("notification_page.landlords_only")}</MenuItem>
              <MenuItem value="everyone">{t("notification_page.everyone")}</MenuItem>
              <MenuItem value="custom">{t("notification_page.special_users")}</MenuItem>
            </Select>
          </FormControl>
          {recipientScope === "custom" && (
            <Box>
              <Autocomplete
                multiple
                options={userList}
                getOptionLabel={(option) =>
                  `${option.FullName} (${option.phone} / ${option.email})`
                }
                groupBy={(option) => option.role}
                filterSelectedOptions
                value={userList.filter((u) => toUserIds.includes(u.id))}
                onChange={(event, newValue) => {
                  setToUserIds(newValue.map((u) => u.id));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={t("notification_page.search_special_users")}
                    placeholder={t("notification_page.search_placeholder")}
                    margin="normal"
                  />
                )}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox checked={selected} style={{ marginRight: 8 }} />
                    {option.avatar_url ? (
                      <Avatar
                        className="notranslate"
                        src={option.avatar_url}
                        sx={{ width: 24, height: 24, mr: 1 }}
                      />
                    ) : (
                      <Avatar
                        sx={{ bgcolor: stringToColor(option.FullName) }}
                        className="notranslate"
                      >
                        {option.FullName.charAt(0).toUpperCase()}
                      </Avatar>
                    )}
                    <Box ml={2} className="notranslate">
                      <Typography variant="body1">
                        {option.FullName} ({option.role})
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {option.email} / {option.phone}
                      </Typography>
                    </Box>
                  </li>
                )}
              />
            </Box>
          )}
          <FormControlLabel
            control={
              <Switch
                checked={sendNow}
                color="info"
                onChange={() => setSendNow(!sendNow)}
              />
            }
            label={t("notification_page.send_now")}
          />
          {!sendNow && (
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale={i18n.language === "ar" ? "ar" : "en"} // Change dynamically
            >
              <DateTimePicker
                label={i18n.language === "ar" ? "تاريخ" : "Date"}
                value={scheduleAt ? dayjs(scheduleAt) : null}
                onChange={(newValue) =>
                  setScheduleAt(newValue ? newValue.format("YYYY-MM-DD HH:mm") : "")
                }
                slotProps={{
                  textField: {
                    placeholder: "", // ✅ Hide placeholder
                    fullWidth: true,
                  },
                }}
              />
            </LocalizationProvider>
            // <TextField
            //   type="datetime-local"
            //   label="Schedule At"
            //   fullWidth
            //   value={scheduleAt}
            //   onChange={(e) => setScheduleAt(e.target.value)}
            //   InputLabelProps={{ shrink: true }}
            //   margin="dense"
            // />
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleSubmit}
            variant="contained"
            color="success"
            sx={{ color: "#fff" }}
          >
            {isSubmit ? t("notification_page.sending") : t("notification_page.send")}
          </Button>
          <Button onClick={() => setOpenDialog(false)}>{t("notification_page.cancel")}</Button>
        </DialogActions>
      </Dialog>
      <ConfirmDialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
        onConfirm={confirmDelete}
        title={t("notification_page.confirm_deletion")}
        content={t("notification_page.confirm_delete_content")}
      />

      <Dialog open={openViewDialog} onClose={() => setOpenViewDialog(false)} fullWidth>
        <DialogTitle>{selectedNotification?.title}</DialogTitle>
        <DialogContent>
          <Typography>{selectedNotification?.message}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenViewDialog(false)}>{t("notification_page.close")}</Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snack.open}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        onClose={() => setSnack({ ...snack, open: false })}
      >
        <Alert severity={snack.severity}>{snack.message}</Alert>
      </Snackbar>
    </Box>
  );
};

export default NotificationPage;
